import { useState } from 'react';
import { Cookies } from 'react-cookie';
import { Link } from 'react-router-dom';
import { ClearSession } from "../Common/Common";

const cookies = new Cookies();
const Header = ({ setOpen, open }) => {
    let UserName = cookies.get('userName');
    let UserCode = cookies.get('loginUserCode')
    let SalesPersonCode = cookies.get('salesPersonCode')

    const [SessionClear, setSessionClear] = useState(false);
    const handleSignOut = async () => {
        setSessionClear(true);
    };
    const toggleFullScreen = () => {
        const elem = document.documentElement;
        if (!document.fullscreenElement) {
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.webkitRequestFullscreen) {
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) {
                elem.msRequestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        }
    }

    return (
        <>
            <header id="header" className="header fixed-top d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center justify-content-between">
                    <a className="navbar-brand" >
                        <img
                            src="assets/img/shop4alllogo.png"
                            className=""
                            alt=""
                            style={{ marginLeft: "24px", width:"175px" }}
                        />
                    </a>
                    <i className="bi bi-list toggle-sidebar-btn" onClick={() => setOpen(!open)} />
                </div>

                <div className="d-flex">
                    <button className="toggle-fullscreen-btn" onClick={toggleFullScreen} style={{ border: "none", backgroundColor: "white" }}>
                        <i className="bi bi-arrows-fullscreen"></i>
                    </button>
                    <nav className="header-nav">
                        <ul className="d-flex align-items-center" style={{ gap: "6px" }}>
                            <li className="nav-item dropdown pe-3">
                                <button
                                    className="nav-link nav-profile d-flex align-items-center pe-0"
                                    data-bs-toggle="dropdown"
                                    style={{ border: "none", backgroundColor: "white" }}
                                >
                                    <img
                                        src="assets/img/profile-img.Png"
                                        alt="Profile"
                                        className="rounded-circle"
                                    />
                                    <span className="d-none d-md-block dropdown-toggle ps-2">
                                        {`${UserName} (${SalesPersonCode ? SalesPersonCode : UserCode})`}
                                    </span>

                                </button>
                                <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                                    <li className="dropdown-header content-left-align">
                                        <h6>{UserName}</h6>
                                        <span>User Code : {SalesPersonCode ? SalesPersonCode : UserCode}</span>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li className="dropdown-header content-left-align">
                                        <Link to="/ChangePassword"> Change Password</Link>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    
                                    <li>
                                        <button className="dropdown-item d-flex align-items-center" onClick={handleSignOut}>
                                            <i className="bi bi-box-arrow-right" />
                                            <span>Sign Out</span>
                                        </button>
                                    </li>
                                </ul>

                            </li>

                        </ul>
                    </nav>
                </div>
            </header>
            {SessionClear ? <ClearSession /> : <></>}
        </>
    )
}
export default Header;